import palette from 'theme/palette';

export default {
  root: {
    background: palette.colors.lightPrimaryBlue,
  },
};
